import { Component, OnInit } from '@angular/core';
import { ModulosService } from './modulos.service';

@Component({
  selector: 'e-modulos',
  templateUrl: './modulos.component.html'
})
export class ModulosComponent implements OnInit {
  public cidade: string = '';

  public urlBrasao: string = '';

  public searchValue: string = '';

  constructor(private modulosService: ModulosService) {}

  ngOnInit(): void {
    this.modulosService.getCidade().subscribe(entidadeCidade => {
      if (entidadeCidade && entidadeCidade.cidade) {
        this.cidade = entidadeCidade.cidade.descricao;
      }
    });

    this.urlBrasao = this.modulosService.getUrlBrasao();
  }
}
